import { IconKey,IconSettings } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconSettings
};
//

const Services = {

    id: 'authentication',
    title: 'Services',
    type: 'group',
    display_id:'F',
    icon: icons.IconSettings,
    children: [
        {
            id: 'Report',
            title: 'Payment Report',
            type: 'item',
            display_id:31,
            url: '/Admin/Payment_report',
            breadcrumbs: false
        },
        {
            id: 'partner_agreement',
            title: "Partner Agreement",
            type: 'item',
            display_id: 30,
            url: '/Admin/Partner_Agreement',
            breadcrumbs: false
        },
        {
            id: 'Service status',
            title: 'Onboarding Status',
            type: 'item',
            display_id:32,
            url: '/Admin/Service_status',
            breadcrumbs: false
        },
        {
            id: 'csp Report',
            title: 'CSP Report',
            type: 'item',
            display_id:34,
            url: '/Admin/Csp_report',
            breadcrumbs: false
        },
        {
            id: 'payment collection',
            title: 'Payment Collection',
            type: 'item',
            display_id:88,
            url: '/Admin/Payment_collection',
            breadcrumbs: false
        },
          {
            id: 'agreement',
            title: 'Agreement',
            type: 'item',
            display_id:101,
            url: '/Admin/agreement',
            breadcrumbs: false
        },
        {
            id: 'user list',
            title: 'User List',
            type: 'item',
            display_id:102,
            url: '/Admin/userlist',
            breadcrumbs: false
        },
        {
            id: 'ds list',
            title: 'DS List',
            type: 'item',
            display_id:103,
            url: '/Admin/Dsuserlist',
            breadcrumbs: false
        },
        {
            id: 'csp_status',
            title: 'CSP Status',
            type: 'item',
            display_id:107,
            url: '/Admin/csp_status',
            breadcrumbs: false
        },
        {
            id: 'fos_list',
            title: 'FOS List',
            type: 'item',
            display_id:118,
            url: '/Admin/fos_list',
            breadcrumbs: false
        },
    ]
}

export default Services;
